<template>
  <div>
    <titulo-modulo titulo="Demonstrativo de Férias" />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <template v-else>
      <v-card flat>
        <v-card-text class="pt-3 pb-1 mt-2">
          <v-row>
            <v-col xl="2" lg="3" md="3" sm="6" cols="12">
              <v-select
                :items="anos"
                label="Ano selecionado"
                v-model="anoSelecionado"
                @change="getDemonstrativosFerias"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-alert v-if="demonstrativos.length == 0" type="info" text class="mt-3">
        Nenhum demonstrativo encontrado para este ano
      </v-alert>
      <lista-concessoes v-else :demonstrativos="demonstrativos" />
    </template>
  </div>
</template>

<script>
import TituloModulo from "../../components/TituloModulo.vue";
import axios from "axios";
import ListaConcessoes from "./components/ListaConcessoes.vue";

export default {
  components: { TituloModulo, ListaConcessoes },
  data: () => ({
    carregando: false,
    anos: [],
    anoSelecionado: 0,
    demonstrativos: [],
  }),
  methods: {
    getAnos() {
      this.anos = [];
      for (
        let ano = new Date().getFullYear();
        ano >= new Date().getFullYear() - 2;
        ano--
      ) {
        this.anos.push(ano);
      }
      this.anoSelecionado = this.anos[0];
    },
    async getDemonstrativosFerias() {
      this.carregando = true;
      this.demonstrativos = [];
      await axios
        .get(`colaborador/recibo-ferias?ano=${this.anoSelecionado}`)
        .then((res) => {
          if (res.data.success) {
            for (const i in res.data.data) {
              let demo = res.data.data[i];
              for (const j in demo.concessoes) {
                let concessao = demo.concessoes[j];
                concessao.cargo = demo.cargo;
                concessao.lotacao = demo.desc_lotacao;
                concessao.ano = this.anoSelecionado;
                this.demonstrativos.push(concessao);
              }
            }
          } else this.$toasted.error(`${res.data.msg}`);
        })
        .catch((e) =>
          this.$toasted.error(
            `Houve um erro ao carregar o demonstrativo de férias. ${e}`
          )
        );
      this.carregando = false;
    },
  },
  async mounted() {
    this.getAnos();
    await this.getDemonstrativosFerias();
  },
};
</script>
